import { render } from "./BarraLateral.vue?vue&type=template&id=427b2052&scoped=true&ts=true"
import script from "./BarraLateral.vue?vue&type=script&lang=ts"
export * from "./BarraLateral.vue?vue&type=script&lang=ts"

import "./BarraLateral.vue?vue&type=style&index=0&id=427b2052&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427b2052"]])

export default __exports__